import { TextAlign } from './TextAlign';
import { TextAlignMainMenu } from './TextAlignMainMenu';
import { TextAlignSubMenu } from './TextAlignSubMenu';
import { SubMenuListContainer } from '@model-framework/menu';

type Props = {
  currentTextAlign?: TextAlign;
  menuSize: number;
  isOpen: boolean;
  onMenuClicked(): void;
  onSelected(textAlign: TextAlign): void;
  text: string;
};

const items = TextAlign.values();

export const TextAlignMenu: React.FC<Props> = ({
  currentTextAlign,
  menuSize,
  isOpen,
  onMenuClicked,
  onSelected,
  text,
}: Props) => {
  const rectSize = {
    width: menuSize * items.length,
    height: menuSize,
  };
  return (
    <g>
      <TextAlignMainMenu menuSize={menuSize} isSelected={isOpen} onClick={onMenuClicked} text={text} />
      {isOpen && (
        <SubMenuListContainer menuSize={menuSize} rectSize={rectSize}>
          {items.map((textAlign, i) => (
            <g key={textAlign} transform={`translate(${menuSize * i}, 0)`}>
              <TextAlignSubMenu
                textAlign={textAlign}
                menuSize={menuSize}
                isSelected={textAlign === currentTextAlign}
                onClick={() => onSelected(textAlign)}
              />
            </g>
          ))}
        </SubMenuListContainer>
      )}
    </g>
  );
};
